import { formatINR, formatDate } from "@/lib/format";

const modeLabel = { cash: "Cash", upi: "PhonePe / GPay / UPI", bank: "Bank Transfer" };

// Rendered once at page root (OUTSIDE any .no-print wrapper) so printing is never blank.
export default function SettlementVoucher({ data }) {
  if (!data) return null;
  const { vehicle: v, total, paidPrev, today, remaining, mode } = data;
  return (
    <div id="print-settlement" style={{ display: "none" }}>
      <div style={{ maxWidth: 460, margin: "0 auto", padding: "20px 24px", fontFamily: "Manrope, sans-serif", color: "#0F172A" }}>
        <div style={{ textAlign: "center", borderBottom: "2px solid #1E3A8A", paddingBottom: 10, marginBottom: 10 }}>
          <img src="/logo.png" alt="A1" style={{ width: 54, height: 54, borderRadius: "50%", margin: "0 auto 4px", display: "block" }} />
          <div style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 20, fontWeight: 900, color: "#1E3A8A", letterSpacing: "-.5px" }}>A1 CARS AGENCY</div>
          <div style={{ fontSize: 11, fontWeight: 600, color: "#64748B" }}>Used Car Sales &amp; Purchase • Since 1981</div>
          <div style={{ fontSize: 13, fontWeight: 800, marginTop: 6, color: "#EA580C", textTransform: "uppercase" }}>Mediator Settlement Voucher</div>
          <div style={{ fontSize: 11, fontWeight: 600, color: "#64748B" }}>Date: {formatDate(new Date())}</div>
        </div>

        <SectTitle>Vehicle</SectTitle>
        <Row label="Make / Model" value={v.model || "—"} strong />
        <Row label="Reg No" value={v.reg_no || "—"} />
        <Row label="Year / Colour" value={`${v.year || "—"} / ${v.color || "—"}`} />

        <SectTitle>Mediator</SectTitle>
        <Row label="Name" value={v.party_name || "—"} strong />
        <Row label="Mobile" value={v.party_mobile || "—"} />

        <SectTitle>Settlement</SectTitle>
        <Row label="Total Purchase Rate" value={formatINR(total)} strong />
        <Row label="Upfront Paid Previously" value={formatINR(paidPrev)} />
        <Row label={`Paid Today (${modeLabel[mode] || mode})`} value={formatINR(today)} strong accent="#16A34A" />
        <Row label="Remaining Held Balance" value={formatINR(remaining)} strong accent={remaining > 0 ? "#EA580C" : "#16A34A"} />

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 40, fontSize: 11, fontWeight: 700 }}>
          <div style={{ borderTop: "1px solid #0F172A", paddingTop: 5, width: "45%", textAlign: "center" }}>Mediator Signature</div>
          <div style={{ borderTop: "1px solid #0F172A", paddingTop: 5, width: "45%", textAlign: "center" }}>A1 Cars (Authorised)</div>
        </div>
        <div style={{ textAlign: "center", fontSize: 10, color: "#94A3B8", marginTop: 12 }}>Computer generated voucher • A1 Cars Agency</div>
      </div>
    </div>
  );
}

function Row({ label, value, strong, accent }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 12, padding: "5px 0", fontSize: 13, borderBottom: "1px dashed #E2E8F0" }}>
      <span style={{ color: "#64748B", fontWeight: 600 }}>{label}</span>
      <span style={{ fontWeight: strong ? 800 : 700, color: accent || "#0F172A", textAlign: "right" }}>{value}</span>
    </div>
  );
}
function SectTitle({ children }) {
  return <div style={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: 1, color: "#94A3B8", margin: "12px 0 4px" }}>{children}</div>;
}
